export type Plan = {
  name: string
  bestFor: string
  priceNote: string
  summary: string
  includes: string[]
  featured?: boolean
}

export const plans: Plan[] = [
  {
    name: 'Custom Site',
    bestFor: 'Established businesses replacing an outdated website',
    priceNote: 'Scoped per project',
    summary: 'A custom-designed, responsive website built around your services, with the CMS and structure to keep it current.',
    includes: [
      'Discovery and business mapping',
      'Custom design system and page templates',
      'CMS setup with content migration',
      'On-page SEO structure and redirects',
      'Managed hosting, SSL, and backups',
      'Team training and launch support',
    ],
  },
  {
    name: 'Custom Commerce',
    bestFor: 'Businesses selling online and tired of platform fees',
    priceNote: 'Scoped per project',
    summary: 'Everything in Custom Site, plus a store built around your pricing, options, and fulfilment — with 0% transaction fees from us.',
    includes: [
      'Everything in Custom Site',
      '0% transaction fees from WebsiteForge',
      'Catalog, variants, and option logic',
      'Account, wholesale, or quote-to-order pricing',
      'Inventory and order API integrations',
      'Checkout and payment configuration',
    ],
    featured: true,
  },
  {
    name: 'Growth & Care',
    bestFor: 'Companies that want us on the tools every month',
    priceNote: 'Monthly retainer',
    summary: 'Ongoing SEO, content, integration work, and updates on the site we built — or on the site you already have.',
    includes: [
      'Human-led SEO with AI-accelerated research',
      'Content and landing page production',
      'Monthly updates and improvements',
      'Integration and workflow builds',
      'Analytics reporting tied to real actions',
      'Priority phone, email, and ticket support',
    ],
  },
]

export const planNotes: string[] = [
  'Every project is quoted after we understand the business — no packages priced before the conversation.',
  'Hosting, SSL, backups, and monitoring are included on the sites we build and maintain.',
  '30-day money-back option: love your site or get your money back.',
]
